var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"divider"}),_vm._v(" "),_c('h4',[_c('span',{staticClass:"title-divider text-uppercase"},[_vm._v(_vm._s(_vm.title))])])])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3635432c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TitleDivider.vue
// module id = fWQL
// module chunks = 102